<template>
  <!--            // TODO-->
  <form-item class="mt-4" tip="禁用图表的演示模式"
             label="禁用演示模式">
  </form-item>
  <el-switch v-model="option.prop.presentDisabled"></el-switch>
  <form-item class="mt-4" tip="初始化是否不加载数据，用于权限过滤等场景需要配合下拉触发加载数据"
             label="初始化不加载数据">
  </form-item>
  <el-switch v-model="option.prop.initUnloadData"></el-switch>
  <form-item label="数据出参处理">
  </form-item>
  <el-input v-model="option.prop.responseHandler">
    <template #suffix>
      <el-button @click="openCode" size="small" :icon="Edit"></el-button>
    </template>
  </el-input>
  <form-item label="图表配置处理">
  </form-item>
  <el-input v-model="option.prop.echartsOptionHandler">
    <template #suffix>
      <el-button @click="openCode('option')" size="small" :icon="Edit"></el-button>
    </template>
  </el-input>
  <form-item class="mt-10" label="数据显示"></form-item>
  <div style="display: flex;align-items: center;">
    <el-input-number v-model='option.prop.limit' size="small" controls-position="right"></el-input-number>
    <span style="margin-left:16px">{{ '条' }}</span>
  </div>
  <JumpSet
      :linkData="linkData"
      :app="app"
      :prop="option.prop"
  ></JumpSet>
  <form-item class="mt-4" tip="结果返回树形结构"
             label="树形结构">
  </form-item>
  <el-switch v-model="option.prop.showTree"></el-switch>
  <template v-if="option.prop.showTree">
    <form-item class="mt-4" tip="树形结构id"
               label="id">
    </form-item>
    <el-select filterable v-model="option.prop.treeCode" value-key="code" clearable size="small">
      <el-option v-for="item in linkDataList" :key="item.code" :label="item.name"
                 :value="item.code"></el-option>
    </el-select>
    <form-item class="mt-4" tip="树形结构父id"
               label="父id">
    </form-item>
    <el-select filterable v-model="option.prop.treeParentCode" value-key="code" clearable size="small">
      <el-option v-for="item in linkDataList" :key="item.code" :label="item.name"
                 :value="item.code"></el-option>
    </el-select>
  </template>
</template>
<script setup>

import {Edit} from "@element-plus/icons-vue";
import JumpSet from "@/option/components/commonSet/jumpSet.vue";

const props = defineProps({
  option: {},
  linkData: {},
  app: {},
  currentLink: {}
})
const emit = defineEmits(['openCode'])
const linkDataList = computed(() => {
  let res = []
  for (const resKey in props.currentLink) {
    let item = props.currentLink[resKey]
    if (resKey !== 'name') {
      res.push({
        name: item.name,
        code: item.code
      })
    }
  }
  return res;
})

function openCode(v) {
  emit('openCode', v)
}
</script>
<style scoped>

</style>